import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { FiGlobe } from "react-icons/fi";
import { FaFilePdf, FaRegFileLines } from "react-icons/fa6";
import { GetUrlOfFiles } from "../apis";
import { motion, scale } from "framer-motion";

const InfiniteScrollForUsedUrls = ({ allUrls = [] }) => {
  const itemsPerLoad = 100;
  const [visibleUrls, setVisibleUrls] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    const initialBatch = allUrls?.slice(0, itemsPerLoad);
    setVisibleUrls(initialBatch);
    setHasMore(initialBatch.length < allUrls.length);
  }, [allUrls]);

  const fetchMoreData = () => {
    const next = visibleUrls.length + itemsPerLoad;
    const nextBatch = allUrls?.slice(visibleUrls.length, next);
    setVisibleUrls((prev) => [...prev, ...nextBatch]);
    if (next >= allUrls.length) {
      setHasMore(false);
    }
  };

  const handelClick = async (ele) => {
    await GetUrlOfFiles(ele?.key_or_urls, ele?.type);
  };

  return (
    <div
      id="scrollableDiv"
      className="flex flex-col gap-2 max-h-72 overflow-y-auto rounded">
      <InfiniteScroll
        dataLength={visibleUrls.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={
          <div className="text-center py-3 text-gray-500 text-sm">
            Loading more...
          </div>
        }
        scrollableTarget="scrollableDiv">
        {visibleUrls.map((ele, index) => {
          let icon = null;
          let displayText = "";

          if (ele?.type === "html") {
            icon = <FiGlobe size={16} />;
            displayText = ele.key_or_urls;
          } else if (ele?.type === "pdf" || ele?.type === "text") {
            icon =
              ele.type === "pdf" ? (
                <FaFilePdf size={16} />
              ) : (
                <FaRegFileLines size={16} />
              );
            displayText = ele.key_or_urls?.split("/")[2];
          }

          return (
            <motion.div
              whileTap={{ scale: 0.99 }}
              key={ele.key_or_urls + index}
              onClick={() => handelClick(ele)}
              className="flex hover:bg-lime-200 cursor-pointer items-center gap-2 my-1 px-3 py-2  rounded-md bg-lime-50 text-sm text-gray-600">
              {icon}
              <span className="break-all">{displayText}</span>
            </motion.div>
          );
        })}
      </InfiniteScroll>
    </div>
  );
};

export default InfiniteScrollForUsedUrls;
